import { Injectable } from '@angular/core';
import { DocumentsToPrint } from "../../models";
import { OauthHelper } from '../../services/webservice'

@Injectable()
export class DocumentDisplayService {

	private deliveryURL = '/api/deliveries/v1';

	constructor(
		private oauthHelper: OauthHelper
	) { }

	public displayDocuments(orderUUID: string, orderSecureId: string, documentsToPrint: DocumentsToPrint) {
		if (documentsToPrint.invoicePrint) {
			window.open(ZUUL_BACKEND + this.deliveryURL + "/invoice/" + orderUUID + "?access_token=" + this.oauthHelper.getAccessToken(), '_blank', '', false)
		}
		if (documentsToPrint.coverLetterPrint) {
				window.
				open(ZUUL_BACKEND + this.deliveryURL + "/" + orderSecureId + "/coverLetter" + "?access_token=" +
					this.oauthHelper.getAccessToken(), '_blank', '', false)
		}
	}

	// This function is currently not used, but it could be used to display the invoice correction in a new tab.

	//public displayInvoiceCorrectionDocument(invoiceCorrectionUuid: string) {
	//	window.open(ZUUL_BACKEND + this.financeURL + "/invoicesPdf/invoiceCorrection/" + invoiceCorrectionUuid + "?access_token=" +
	//		this.oauthHelper.getAccessToken(), '_blank', '', false)
	// }
}



// WEBPACK FOOTER //
// ./src/app/components/documents/document-display.service.ts